import {MouseEvent} from 'react';
import cn from 'classnames';

import {appendQueryParamToUrl} from '@zzng/common/utils/common';
import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import {BestSection} from '@/root/models/home';

import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';
import {nl2br} from '@/shared/utils/nl2br';

interface Props {
  bestSection: BestSection;
}

const CardBestSection = ({bestSection}: Props) => {
  const isWhiteType = bestSection.textColor === 'WHITE';
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  const openEventBenefitDetail = (url: string) => {
    openLandingUrl(url);
  };

  const onClickBestSection = (e: MouseEvent<HTMLButtonElement>) => {
    /** 스크롤 최상단 이동 막음 */
    e.preventDefault();

    // 이벤트 상세 페이지 진입시 헤더 타입을 CLOSE로 변경하기 위해 direct=true를 추가
    const landgingUrl = appendQueryParamToUrl(bestSection.landingUrl, {direct: true});

    trackEvent({
      action: TIARA_ACTION.BEST_BENEFIT_CLICK,
      customProps: {title: bestSection.title, url: landgingUrl}
    });

    openEventBenefitDetail(landgingUrl);
  };

  return (
    <button
      type="button"
      role="link"
      className={cn('link_banner', {type_white: isWhiteType, type_dark: !isWhiteType})}
      style={{
        backgroundImage: `url(${bestSection.bgImageUrl})`,
        backgroundColor: bestSection.backgroundColor
      }}
      onClick={onClickBestSection}
    >
      <strong className="tit_banner" role="text">
        {nl2br(bestSection.title)}
      </strong>
      <span className="txt_sub">{bestSection.subTitle}</span>
      <span className="txt_more">상세보기</span>
    </button>
  );
};

export default CardBestSection;
